import React from 'react';
import Icon from '../../../components/AppIcon';

const NextStepsSection = () => {
  const nextSteps = [
    {
      id: 'phone',
      icon: 'Phone',
      title: 'Restez joignable',
      description: 'Assurez-vous de rester disponible pour l\'étape de vérification par appel "facetime" réalisé par notre Avocat.',
      action: 'Mettre à jour le numéro',
      actionType: 'internal'
    }
  ];

  const handleActionClick = (step) => {
    if (step.actionType === 'external' && step.id === 'email') {
      // Open default email client
      window.location.href = 'mailto:';
    } else {
      // Handle internal actions
      console.log(`Action clicked for: ${step.id}`);
    }
  };

  return (
    <div className="bg-surface rounded-xl border border-border shadow-elevation-2 p-6 mb-8">
      <div className="flex items-center mb-6">
        <Icon name="CheckSquare" size={24} color="#059669" className="mr-3" />
        <h2 className="text-xl font-semibold text-text-primary font-inter">
          Prochaines étapes
        </h2>
      </div>

      <div className="space-y-6">
        {nextSteps.map((step, index) => (
          <div key={step.id} className="flex items-start space-x-4 p-4 rounded-lg border border-border-light hover:bg-secondary-50 transition-smooth">
            {/* Step Icon */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-accent-50 rounded-lg flex items-center justify-center">
                <Icon name={step.icon} size={20} color="#059669" />
              </div>
            </div>

            {/* Step Content */}
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-medium text-text-primary mb-2 font-inter">
                {step.title}
              </h3>
              <p className="text-sm text-text-secondary mb-3 font-inter">
                {step.description}
              </p>
            </div>

            {/* Arrow Icon */}
            <div className="flex-shrink-0">
              <Icon name="ChevronRight" size={16} color="#9CA3AF" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextStepsSection;